import { Button, Flex, Layout, Modal, Tooltip, Form, Input, Select, Upload, message, Segmented } from "antd";
import { TbGrid4X4, TbLayoutGrid, TbList, TbUpload } from "react-icons/tb";
import { useState } from "react";
import ListView from "components/ListView";
import GridView from "components/GridView";
import PageTitle from "components/PageTitle";

import FileUpload from "components/FileUpload";
import DashboardLayout from "layout/DashboardLayout";

import { ApiService } from "api/api.service";

const { Option } = Select;
const { Dragger } = Upload;

const Gallery = () => {
  const [isListview, setIsListView] = useState(true);
  const [modal2Open, setModal2Open] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const createMedia = ApiService.media.useCreateMedia();

  const [form] = Form.useForm();

  const handleFileChange = (info: any) => {
    const { fileList } = info;
    setUploadedFiles(fileList);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        // Check if files are uploaded
        if (!uploadedFiles.length) {
          message.error("Please upload at least one file.");
          return;
        }

        // Create a FormData object
        const formData = new FormData();

        // Append form values to the FormData object
        formData.append("title", values.title);
        formData.append("caption", values.caption);
        formData.append("type", values.type);
        formData.append("tags", JSON.stringify(values.tags)); // Convert tags to JSON string

        // Append files to the FormData object
        uploadedFiles.forEach((file: any) => {
          formData.append("file", file.originFileObj); // 'originFileObj' is the actual file
        });

        // Send the formData instead of the direct values
        createMedia.mutate(formData, {
          onSuccess: () => {
            message.success("Media updated successfully");
            setModal2Open(false);
            form.resetFields();
            setUploadedFiles([]);
          },
          onError: () => {
            message.error("Failed to update media.");
          },
        });
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  return (
    <DashboardLayout
      headerRight={
        <div className="inline-flex gap-2">
          <Segmented
            options={[
              {
                value: true,
                icon: <TbList />,
              },
              { value: false, icon: <TbLayoutGrid /> },
            ]}
            onChange={(value) => setIsListView(value)}
          />
          <Button onClick={() => setModal2Open(true)} type="primary" icon={<TbUpload />}>
            Upload
          </Button>
        </div>
      }
    >
      <PageTitle title="Gallery" pageTitle={[{ title: "Gallery" }]} />

      {isListview ? <ListView /> : <GridView blogPage={false} />}
      <Modal
        title="Upload Files"
        centered
        open={modal2Open}
        onOk={handleOk}
        onCancel={() => {
          setModal2Open(false);
          setUploadedFiles([]);
        }}
      >
        <Form form={form} layout="vertical" initialValues={{ type: "image" }}>
          <Form.Item label="Title" name="title" rules={[{ required: true, message: "Please enter a title" }]}>
            <Input placeholder="Enter title" />
          </Form.Item>

          <Form.Item label="Caption" name="caption">
            <Input placeholder="Enter caption" />
          </Form.Item>

          <Form.Item label="Tags" name="tags" rules={[{ required: true, message: "Please enter tags" }]}>
            <Select mode="tags" style={{ width: "100%" }} placeholder="Enter tags" />
          </Form.Item>

          <Form.Item label="Type" name="type" rules={[{ required: true, message: "Please select a type" }]}>
            <Select>
              <Option value="audio">Audio</Option>
              <Option value="image">Image</Option>
              <Option value="video">Video</Option>
            </Select>
          </Form.Item>

          {/* File Upload Section */}
          <Form.Item label="Upload Files" name="files">
            <Dragger
              multiple
              fileList={uploadedFiles}
              onChange={handleFileChange}
              beforeUpload={() => false} // Prevent automatic upload, handle it manually
              listType="picture"
            >
              <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <p className="ant-upload-drag-icon">
                  <TbUpload size={28} />
                </p>
                <p className="ant-upload-text">Click or drag files to this area to upload</p>
                <p className="ant-upload-hint">Supports single or bulk upload.</p>
              </div>
            </Dragger>
          </Form.Item>
        </Form>
      </Modal>
    </DashboardLayout>
  );
};

export default Gallery;
